import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Employee } from '..';
import { EmployeeSkillsCard } from '../../../pages/Skills';
import { EmployeeSkillGap } from '../../../components/SkillGap';

type Props = {
  employee: Employee;
};

export const EmployeeSkills: React.FC<React.PropsWithChildren<Props>> = ({
  employee,
}) => {
  return (
    <Row>
      <Col lg={8}>
        <EmployeeSkillsCard
          employeeId={employee.Id}
          employeeName={employee.Name}
        />
      </Col>
      <Col lg={4}>
        <EmployeeSkillGap employeeId={employee.Id} />
      </Col>
    </Row>
  );
};
